define('customPlugins/atnKendoDatePicker',[
        'jquery', 'knockout', 'kendo-knockout'
    ],
    function($, ko) {
        'use strict';

        ko.bindingHandlers.atnKendoDatePicker = {
            init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var options = valueAccessor();
                options.format = options.format || 'MMM dd yyyy';
                if (options.atnReadonly === true) {
                    // the atnReadonly field indicates that the input element of the kendo datePicker should be readonly;
                    // we make it readonly, by removing the focus on the element.
                    element.onclick = datePickerBlur;
                    element.onkeydown = datePickerBlur;
                }
                var valueAccessorFn = function() {
                    return options;
                };
                ko.bindingHandlers.kendoDatePicker.init(element, valueAccessorFn, allBindings, viewModel, bindingContext);
            },
            update: ko.bindingHandlers.kendoDatePicker.update
        };



        /**
         * datePickerBlur: use the blur method to remove the focus on the HTML element.
         * @e {MouseEvent/KeyboardEvent : whatever event that triggers the focus on the HTML element}
         */
        function datePickerBlur(e) {
            e.srcElement.blur();
        }

    });

